// extracted by mini-css-extract-plugin
export default {"container":"Term_container__5DsTV","pointer":"Term_pointer__09js6","label":"Term_label__CrwTX","value":"Term_value__YeB-b"};